module.exports = __webpack_public_path__ + "static/media/Inbox.223af67f.jpg";